// extracted by mini-css-extract-plugin
module.exports = {"pt-withdraw-table":"pt-withdraw-table-37b71e71dfc50b1de657a0209303f335","table-tip-text":"table-tip-text-13cbab43c9885ee13f296f7a8c4ea0d5"};